import React from 'react';
type BookCoverProps = {
  kicker: string;
  title: string;
  number?: string;
  accent?: string;
  size?: 'sm' | 'md';
  className?: string;
};

/**
 * Code-drawn product cover (navy + gold). Stands in for rendered mockups
 * until the real Bootcamp Ready covers are produced.
 */
export function BookCover({
  kicker,
  title,
  number,
  accent = 'bg-gold',
  size = 'md',
  className = ''
}: BookCoverProps) {
  const sm = size === 'sm';
  return <div className={`relative aspect-[2/3] overflow-hidden rounded-[6px] border border-white/10 bg-gradient-to-br from-navy-mid via-navy to-navy-deep shadow-book ${className}`} data-id="element-38" data-mp="2o6zlau6i1ye4">
      <span className={`absolute inset-y-0 left-0 w-[7%] ${accent}`} aria-hidden="true" data-id="element-39" data-mp="2egd8f7q63lz4" />
      <span className="absolute -right-6 -top-6 h-20 w-20 rounded-full bg-gold/10 blur-2xl" aria-hidden="true" data-id="element-40" data-mp="29enxrt6uxabk" />
      <div className="relative flex h-full flex-col justify-between py-[11%] pl-[16%] pr-[10%]" data-id="element-41" data-mp="20gcd07so96r1">
        <div data-id="element-42" data-mp="19b146wo6zwzc">
          <p className={`font-bold uppercase tracking-[0.18em] text-gold ${sm ? 'text-[6.5px] sm:text-[7.5px]' : 'text-[9px]'}`} data-id="element-43" data-mp="19ahmnh2gfalu">
            {kicker}
          </p>
          {number && <p className={`mt-1 font-display font-bold leading-none text-white/15 ${sm ? 'text-3xl sm:text-4xl' : 'text-5xl'}`} data-id="element-44" data-mp="zeemuhv2ro22">
              {number}
            </p>}
        </div>
        <p className={`font-display font-bold uppercase leading-[0.95] text-white ${sm ? 'text-[12px] sm:text-[15px]' : 'text-[19px]'}`} data-id="element-45" data-mp="1x0vfvawrzfi0">
          {title}
        </p>
        <div className="flex items-center gap-1.5" data-id="element-46" data-mp="1n1edb2ctlhq9">
          <span className="h-px flex-1 bg-gold/50" data-id="element-47" data-mp="1n40kv1zpnx8h" />
          <span className={`whitespace-nowrap font-bold uppercase tracking-widest text-white/55 ${sm ? 'text-[5.5px] sm:text-[6.5px]' : 'text-[8px]'}`} data-id="element-48" data-mp="7kci5u9043fd">
            Bootcamp Ready
          </span>
        </div>
      </div>
    </div>;
}